
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ProductDetail from "./pages/ProductDetail";
import Auth from "./pages/Auth";
import { Toaster } from "./components/ui/toaster";
import { ThemeProvider } from "./providers/ThemeProvider";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Category from "./pages/Category";
import Profile from "./pages/Profile";
import AccountActivated from "./pages/AccountActivated";
import Coins from "./pages/Coins";
import Search from "./pages/Search";
import AdminDashboard from "./pages/AdminDashboard";
import UserProfile from "./pages/UserProfile";
import Messages from "./pages/Messages";
import ResetPassword from "./pages/ResetPassword";
import EditListing from "./pages/EditListing";
import CookieConsent from "./components/ui/CookieConsent";
import { AuthProvider } from "./context/AuthContext";
import CreateListing from "./pages/CreateListing";
import Safety from "./pages/Safety";
import Help from "./pages/Help";
import Cmime from "./pages/Cmime";
import Contact from "./pages/Contact";
import ProfileSettings from "./pages/ProfileSettings"
import Favorites from "./pages/Favorites"
import { SupportChat } from "./components/support/SupportChat"; 
import RegistrationSuccess from "./pages/RegistrationSuccess";
import ListingDetail from "./pages/ListingDetail";
import InstallPrompt from "./components/ui/InstallPrompt";
import PasswordResetEmailSent from "./pages/PasswordResetEmailSent";
import EmailConfirmation from "./pages/EmailConfirmation";
import RecoveryCodeHandler from "./components/auth/RecoveryCodeHandler";
import PurchasesPage from "./pages/Purchases";
import SalesPage from "./pages/Sales";
import Stores from "./pages/Stores";

export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <RecoveryCodeHandler />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* New SEO-friendly product URLs with slug support */}
          <Route path="/product/:idSlug" element={<ProductDetail />} />
          {/* New SEO-friendly store URLs with slug support */}
          <Route path="/store/:idSlug" element={<UserProfile />} />
          {/* New SEO-friendly category URLs with slug support */}
          <Route path="/category/:idSlug" element={<Category />} />
          {/* New SEO-friendly search category URLs */}
          <Route path="/search/:categoryIdSlug" element={<Search />} />
          {/* Old listing redirect for backward compatibility */}
          <Route path="/listing/:id" element={<ListingDetail />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/create-listing" element={<CreateListing />} />
          <Route path="/auth/account-activated" element={<AccountActivated />} />
          <Route path="/auth/registration-success" element={<RegistrationSuccess />} />
          <Route path="/auth/password-reset-sent" element={<PasswordResetEmailSent />} />
          <Route path="/email-confirmation" element={<EmailConfirmation />} />
          <Route path="/coins" element={<Coins />} />
          <Route path="/profile/settings" element={<ProfileSettings />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/purchases" element={<PurchasesPage />} />
          <Route path="/sales" element={<SalesPage />} />
          <Route path="/search" element={<Search />} />
          <Route path="/stores" element={<Stores />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/user-profile" element={<UserProfile />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/edit-listing/:id" element={<EditListing />} />
          <Route path="/safety" element={<Safety />} />
          <Route path="/help" element={<Help />} />
          <Route path="/cmime" element={<Cmime />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
        <CookieConsent />
        <SupportChat />
        <InstallPrompt />
      </ThemeProvider>
    </AuthProvider>
  );
}
